module.exports = __webpack_public_path__ + "images/emoji/speak_no_evil.07dd75c52407bbe87e0c.png";